import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useToggleSavedUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ userId, isSaved }: { userId: string; isSaved: boolean }) => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      if (isSaved) {
        // Remove from saved
        const { error } = await supabase
          .from("saved_users")
          .delete()
          .eq("user_id", user.id)
          .eq("saved_user_id", userId);

        if (error) throw error;
      } else {
        // Add to saved
        const { error } = await supabase
          .from("saved_users")
          .insert({
            user_id: user.id,
            saved_user_id: userId,
          });

        if (error) throw error;
      }

      return { userId, isSaved: !isSaved };
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["saved-users"] });
      queryClient.invalidateQueries({ queryKey: ["is-saved", data.userId] });
      
      toast.success(
        data.isSaved ? "Added to your interaction list" : "Removed from your interaction list"
      );
    },
    onError: (error) => {
      console.error("Error toggling saved user:", error);
      toast.error("Failed to update interaction list");
    },
  });
};
